<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DB8wlY/tc-custom/9781532400377.jpg?1702237035171" alt="This image is the cover for the book Tale of the Flopsy Bunnies, Xist Illustrated Children's Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tale of the Flopsy Bunnies, Xist Illustrated Children's Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>Benjamin Bunny’s offspring learn the perils of gluttony in this charming story from the popular author of <i>The Tale of Peter Rabbit</i>.</b><br/>  <br/> In this story, Benjamin Bunny’s children, the Flopsy Bunnies, eat so much lettuce from Mr. McGregor’s garden that they become sleepy and are almost turned into a rabbit pie. <i>The Tale of the Flopsy Bunnies </i>by Beatrix Potter is part of the Xist Publishing Children’s Classics collection. Each ebook has been specially formatted with full-screen, full-color illustrations and the original, charming text. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beatrix Potter
      </h2>
      
      <p class="authorDescription body article">Beatrix Potter (1866-1943) was an English children&rsquo;s book writer, best known for her Peter Rabbit series. Born to a wealthy family in English, Beatrix did not go to school and instead stayed at home, spending much of her time drawing and creating stories based on animals. In her 20&rsquo;s, Beatrix attempted to get her children&rsquo;s book and drawings published. Finally, in 1902 her first book, <I>The Tale of Peter Rabbit</I>, was published, selling over 28,000 copies the first year. This series brought her fame and wealth. She went on to write 23 books. These works have had a profound impact on illustrated children&rsquo;s books to this day.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Xist Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a7bcbf9